/* Turkish labels for the asynchronously rendered Fastr wishlist embeds.
 * Keep the vendor's DOM, handlers, product data and saved list names intact.
 */
(() => {
  if (document.documentElement.lang.split('-')[0] !== 'tr') return;

  const labels = new Map([
    ['Wishes become toys, toys become PLAY!', 'Dilekler oyuncağa, oyuncaklar EĞLENCEYE!'],
    ['Wishes', 'Dilekler'],
    ['become PLAY!', 'EĞLENCEYE dönüşür!'],
    ['Share their wish', 'Listeyi paylaş'],
    ['Share my wish', 'Listemi paylaş'],
    ['+ Add a new list', '+ Yeni liste ekle'],
    ['Add to Cart', 'Sepete ekle'],
    ['My Wishlist', 'Favorilerim'],
    ['remove from wishlist', 'favorilerden kaldır'],
    ['Choose a wishlist', 'Bir liste seç'],
    ['Create Wishlist', 'Liste oluştur'],
    ['Make a Wish,', 'Bir dilek tut,'],
    ['Make It Yours', 'Senin olsun']
  ]);
  const selector = '.fastr-container .text-node, .fastr-container input[placeholder], [aria-label*="wishlist" i], [title*="wishlist" i]';

  function translate(element) {
    for (const attribute of ['aria-label', 'title']) {
      const label = element.getAttribute(attribute)?.trim().toLowerCase();
      if (label === 'add to wishlist') element.setAttribute(attribute, 'Favorilere ekle');
      if (label === 'remove from wishlist') element.setAttribute(attribute, 'Favorilerden kaldır');
    }
    if (element.matches('input')) {
      if (element.getAttribute('placeholder') === 'Wishlist Name') {
        element.setAttribute('placeholder', 'Liste adı');
        element.setAttribute('aria-label', 'Liste adı');
      }
      return;
    }
    // Edit text nodes only: replacing innerHTML would discard vendor bindings.
    for (const node of element.childNodes) {
      if (node.nodeType !== Node.TEXT_NODE) continue;
      const translated = labels.get(node.textContent.trim());
      if (translated) node.textContent = node.textContent.replace(node.textContent.trim(), translated);
    }
  }

  function scan(node) {
    const element = node.nodeType === Node.TEXT_NODE ? node.parentElement : node;
    if (!(element instanceof Element)) return;
    if (element.matches(selector)) translate(element);
    element.querySelectorAll(selector).forEach(translate);
  }

  scan(document.body);
  // The vendor attaches its dialogs directly to body after the page has loaded.
  // Process only changed subtrees, never rescan the entire page on each mutation.
  new MutationObserver((records) => {
    for (const record of records) {
      if (record.type === 'childList') record.addedNodes.forEach(scan);
      else scan(record.target);
    }
  }).observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['placeholder', 'aria-label', 'title']
  });
})();
